import { ref as y, computed as C, getCurrentInstance as h, resolveComponent as v, openBlock as n, createBlock as g, resolveDynamicComponent as b, normalizeClass as I, withCtx as _, createElementBlock as a, renderSlot as c, createCommentVNode as o, createTextVNode as r, createElementVNode as p, toDisplayString as m } from "vue";
import B from "./design-system.es58.js";
/* empty css                    */
/* empty css                    */
import L from "./design-system.es128.js";
function D(t, i) {
  return t != null && t.target && i ? t.target === i || i.contains(t.target) : !1;
}
const E = {
  name: "DsListItemLegacy",
  components: {
    DsIcon: B
  },
  props: {
    /**
     * Root element type
     */
    as: {
      type: String,
      default: "div"
    },
    /**
     * Main text to show on the list item
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * Description text to display. This will truncate after two lines (or one line if shortDescription is used).
     */
    description: {
      type: String,
      default: ""
    },
    /**
     * Another line of description text. This will truncate to one line.
     */
    shortDescription: {
      type: String,
      default: ""
    },
    /**
     * Leading icon
     */
    leadingIcon: {
      type: String,
      default: null
    },
    /**
     * Trailing icon
     */
    trailingIcon: {
      type: String,
      default: null
    },
    /**
     * The style in which to display the border below the list item.
     */
    borderStyle: {
      type: String,
      default: "partial",
      options: ["none", "partial", "full"]
    },
    /**
     * Show interactive hover state
     */
    clickable: Boolean,
    preventLeadingClick: Boolean,
    preventTrailingClick: Boolean
  },
  emits: ["click"],
  setup(t, { slots: i, emit: e }) {
    const l = y(null), u = y(null), f = C(() => {
      var s, k;
      return t.clickable || t.as === "a" || !!((k = (s = h()) == null ? void 0 : s.vnode.props) != null && k.onClick);
    }), d = C(() => !!t.shortDescription || !!i.shortDescription);
    function S(s) {
      t.preventLeadingClick && D(s, l.value) || t.preventTrailingClick && D(s, u.value) || e("click", s);
    }
    return {
      leading: l,
      trailing: u,
      isClickable: f,
      hasShortDescription: d,
      handleClick: S
    };
  }
}, N = {
  key: 0,
  ref: "leading",
  class: "leading-slot"
}, T = { class: "list-item-info" }, V = { class: "item-text" }, w = {
  key: 0,
  class: "title one-line"
}, z = {
  key: 2,
  class: "description one-line"
}, j = {
  key: 0,
  ref: "trailing",
  class: "trailing-slot"
};
function q(t, i, e, l, u, f) {
  const d = v("DsIcon");
  return n(), g(b(e.as), {
    class: I(["list-item", [`border-${e.borderStyle}`, { clickable: l.isClickable }]]),
    onClick: l.handleClick
  }, {
    default: _(() => [
      t.$slots.leading || e.leadingIcon ? (n(), a("div", N, [
        c(t.$slots, "leading", {}, () => [
          e.leadingIcon ? (n(), g(d, {
            key: 0,
            name: e.leadingIcon
          }, null, 8, ["name"])) : o("", !0)
        ], !0)
      ], 512)) : o("", !0),
      i[3] || (i[3] = r()),
      p("div", T, [
        p("div", V, [
          e.title || t.$slots.title ? (n(), a("div", w, [
            c(t.$slots, "title", {}, () => [
              r(m(e.title), 1)
            ], !0)
          ])) : o("", !0),
          i[0] || (i[0] = r()),
          e.description || t.$slots.description ? (n(), a("div", {
            key: 1,
            class: I(["description", [{ "one-line": l.hasShortDescription }]])
          }, [
            c(t.$slots, "description", {}, () => [
              r(m(e.description), 1)
            ], !0)
          ], 2)) : o("", !0),
          i[1] || (i[1] = r()),
          l.hasShortDescription ? (n(), a("div", z, [
            c(t.$slots, "shortDescription", {}, () => [
              r(m(e.shortDescription), 1)
            ], !0)
          ])) : o("", !0)
        ]),
        i[2] || (i[2] = r()),
        t.$slots.trailing || e.trailingIcon ? (n(), a("div", j, [
          c(t.$slots, "trailing", {}, () => [
            e.trailingIcon ? (n(), g(d, {
              key: 0,
              name: e.trailingIcon
            }, null, 8, ["name"])) : o("", !0)
          ], !0)
        ], 512)) : o("", !0)
      ])
    ]),
    _: 3
  }, 8, ["class", "onClick"]);
}
const K = /* @__PURE__ */ L(E, [["render", q], ["__scopeId", "data-v-9835a997"]]);
export {
  K as default
};
//# sourceMappingURL=design-system.es288.js.map
